import React from 'react';
import { notifications } from '../../utils';
import Grid from '@material-ui/core/Grid';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Icon,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import { useStyles } from './styles';
import { FarmContactViewModel, FarmSettingsContactType } from '../../models/user';
import { validateEmail } from '../../utils';
import { useTranslation } from 'react-i18next';

interface FarmContactAddModalProps {
  opened: boolean;
  onModalAction: (doctor: FarmContactViewModel | null) => void;
}

const FarmContactAddModal: React.FC<any> = ({ opened, onModalAction }: FarmContactAddModalProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [info, setInfo] = React.useState('');
  const [contactType, setContactType] = React.useState(100 as FarmSettingsContactType);

  const closeDialog = (text: string | null) => {
    if (text == null) {
      onModalAction(null);
      clearFields();
      return;
    }

    if (!validate()) {
      return;
    }

    onModalAction({
      name,
      email,
      phone,
      info,
      type: contactType
    } as FarmContactViewModel);

    clearFields();
  };

  const validate = (): boolean => {
    if (!name) {
      notifications.warning(t('f-val-con-name'));
      return false;
    }

    if (!email) {
      notifications.warning(t('f-val-con-email'));
      return false;
    } else {
      if (!validateEmail(email)) {
        notifications.warning(t('f-val-con-email-val'));
        return false;
      }
    }

    return true;
  };

  const clearFields = () => {
    setName('');
    setPhone('');
    setEmail('');
    setInfo('');
  };

  return (
    <Dialog
      id="addFarmContactModal"
      open={opened}
      onClose={() => closeDialog(null)}
      className={classes.dialog}
      maxWidth="sm"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="addFarmDoctorModalTitle" className={classes.dialogHeaderFooter}>
        {t('f-settings-add-con-title')}
      </DialogTitle>

      <DialogContent>
        <Grid container direction="column" spacing={1} className={classes.updateForm}>
          <Grid item>
            <TextField
              label={t('f-settings-con-name')}
              variant="outlined"
              size="small"
              className={classes.formControl}
              helperText={t('f-com-req')}
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </Grid>

          <Grid item>
            <TextField
              label={t('f-com-email')}
              variant="outlined"
              size="small"
              className={classes.formControl}
              helperText={t('f-com-req')}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </Grid>

          <Grid item>
            <TextField
              label={t('f-com-phone')}
              variant="outlined"
              size="small"
              className={classes.formControl}
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </Grid>

          <Grid item>
            <TextField
              label={t('f-com-info')}
              variant="outlined"
              size="small"
              multiline
              className={classes.formControl}
              value={info}
              onChange={(e) => {
                setInfo(e.target.value);
              }}
            />
          </Grid>

          <Grid item>
            <FormControl className={classes.formControl} fullWidth>
              <InputLabel id="contact-type-lbl">{t('f-settings-farm-cont-type')}</InputLabel>
              <Select
                labelId="contact-type-lbl"
                id="contact-type-select"
                value={contactType}
                onChange={(e) => {
                  setContactType(e.target.value as FarmSettingsContactType);
                }}
              >
                <MenuItem value={FarmSettingsContactType.Doctor}>{t('f-settings-farm-cont-type-doc')}</MenuItem>

                <MenuItem value={FarmSettingsContactType.Manager}>{t('f-settings-farm-cont-type-manager')}</MenuItem>

                <MenuItem value={FarmSettingsContactType.Supplier}>{t('f-settings-farm-cont-type-supplier')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className={classes.dialogHeaderFooter}>
        <Button onClick={() => closeDialog(null)} variant="outlined" startIcon={<Icon>{'close'}</Icon>} color="primary">
          {t('f-com-cancel')}
        </Button>

        <Button
          onClick={() => closeDialog('ok')}
          id="saveBtn"
          startIcon={<Icon>{'add_circle_outline'}</Icon>}
          variant="contained"
          color="primary"
        >
          {t('f-com-add')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FarmContactAddModal;
